import api from '../../../../api'

export const FETCH_VEHICLES_CUSTOMER_PENDING = 'FETCH_VEHICLES_CUSTOMER_PENDING'
export const FETCH_VEHICLES_CUSTOMER_FULFILLED = 'FETCH_VEHICLES_CUSTOMER_FULFILLED'
export const FETCH_VEHICLES_CUSTOMER_REJECTED = 'FETCH_VEHICLES_CUSTOMER_REJECTED'

export const DELETE_VEHICLES_CUSTOMER_PENDING = 'DELETE_VEHICLES_CUSTOMER_PENDING'
export const DELETE_VEHICLES_CUSTOMER_FULFILLED = 'DELETE_VEHICLES_CUSTOMER_FULFILLED'
export const DELETE_VEHICLES_CUSTOMER_REJECTED = 'DELETE_VEHICLES_CUSTOMER_REJECTED'

export const CHANGE_VEHICLES_CUSTOMER = 'CHANGE_VEHICLES_CUSTOMER'

export function changeVehiclesCustomer(name, value) {
  return dispatch => {
    dispatch({ type: CHANGE_VEHICLES_CUSTOMER, payload: { name, value } })
  }
}

export function findAllVehiclesCustomers(filter, first = 1000, offset = 0) {

  return dispatch => new Promise((resolve, reject) => {

    dispatch({ type: FETCH_VEHICLES_CUSTOMER_PENDING });
    /**
      velocidadeTipo: ${filter.velocidadeTipo}
      velocidadeValor: ${filter.velocidadeValor}
     */
    api({
      method: 'post',
      data: {
        query: `
                query findAllVehiclesCustomers {
                  relatorioPosicoes(
                    cliId: 784
                    veiId: ${filter.veiculo}
                    parDhi: "${filter.dataHoraInicial}"
                    parDhf: "${filter.dataHoraFinal}"
                    velTip: ${filter.velocidadeTipo}
                    velVlr: ${filter.velocidadeValor}
                    first: ${first} offset: ${offset}) {
                    veiId
                    veiCod
                    veiPlc
                    veiDsc
                    cliDsc
                    ptpDsc
                    ddlDh
                    ddlVel
                    ddlIgn
                    ddlLat
                    ddlLng
                    ddlDir
                    ddlIgn
                    ddlOdm
                    ddlTen
                  }
                }
                `
      }
    }).then((result) => {
      const { errors, data } = result.data
      if (errors) {
        dispatch({ type: FETCH_VEHICLES_CUSTOMER_REJECTED, payload: errors });
        reject(errors);
      } else {
        const { relatorioPosicoes } = data
        dispatch({ type: FETCH_VEHICLES_CUSTOMER_FULFILLED, payload: relatorioPosicoes });
        resolve(data);
      }
    }).catch((error) => {
      dispatch({ type: FETCH_VEHICLES_CUSTOMER_REJECTED, error });
      reject(error);
    });

  });

}
